import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function LatestUpdate() {
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  ).slice(0, 6);

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1 h-5 rounded-full bg-accent-500"></div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
              最近更新
            </h2>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} size="medium" />
          ))}
        </div>
      </div>
    </section>
  );
}